import tw from "twin.macro"

// homepage

export const paragraphStyles = tw`text-white text-sm mb-4 leading-[1.1] md:(text-lg leading-120)`

export const greenHeading = tw`font-kanit tracking-[0.005rem] text-green font-bold  text-xl  leading-5 md:(text-[32px] leading-7)`

export const purpleHeading = [
  greenHeading,
  tw`text-light-purple font-semibold text-base uppercase mb-1.5 lg:(mb-4 text-xl)`,
]

export const darkPurpleHeading = [
  greenHeading,
  tw`text-purple  text-2xl leading-[0.96] mb-2 lg:(mb-4 text-5xl)`,
]

export const btnStyles = tw`border-transparent font-kanit tracking-[0.005rem] bg-purple font-semibold rounded-[100px] text-white text-center py-1.5 px-6 leading-120 hover:(bg-green text-purple) md:(font-bold text-lg) md:(leading-[0] py-[25px] px-6 )`

export const panelStyles = tw`h-screen w-screen bg-white relative`

export const button = tw`font-kanit tracking-[0.005rem] transition duration-300 text-center font-bold py-4 px-6 w-full rounded-[100px] text-base cursor-pointer leading-[1.2] lg:(text-xl px-8 leading-[0.9] w-auto)`

export const buttonPurple = [
  button,
  tw`bg-purple text-tan hover:(bg-green text-purple)`,
]

export const buttonGreenPurple = [
  button,
  tw`bg-green text-purple hover:(bg-purple text-white)`,
]

export const buttonGreenViolet = [
  button,
  tw`bg-green text-purple hover:(bg-violet text-white)`,
]

export const buttonPurpleOutline = [
  button,
  tw`bg-transparent border-[1.5px] border-purple text-purple hover:(bg-purple text-white)`,
]

export const buttonDisabled = [
  button,
  tw`bg-disabled-gray text-tan cursor-not-allowed hover:(bg-disabled-gray text-tan)`,
]

export const pSuperStyles = tw`-top-1  lg:-top-1.5`
